// set

export const SET = 'ui.error.SET' as const;
export type SetPayload = {
	message: string;
};
export type SetAction = {
	type: typeof SET;
	payload: SetPayload;
};
export const set = (payload: SetPayload): SetAction => ({
	type: SET,
	payload,
});

export type Action = SetAction;
